import React from "react";
import SettingComponent from "../../../components/Settings/Settings";
import DashboardTopSearch from "../../../components/DashboardTopSearch/DashboardTopSearch";
import AdminNotification from "../../../components/Notification/AdminNotification";
import { useSelector } from "react-redux";

const AdminSettings = () => {
  const auth = useSelector((state) => state.auth);
  
  return (
    <>
      <div className="topbar mb-20 mb-lg-36">
        <div className="d-flex align-items-center justify-content-between">
          <h3 className="ad-heading-04 fw-bold mb-8">Admin Settings</h3>
          <div className="search-wrapper d-none d-lg-flex align-items-center gap-3">
            <DashboardTopSearch />
            <AdminNotification />
          </div>
        </div>
      </div>
      <SettingComponent userRole="admin" />
    </>
  );
};

export default AdminSettings;
